import { render, staticRenderFns } from "./QueueSelect.vue?vue&type=template&id=427b7252"
import script from "./QueueSelect.vue?vue&type=script&lang=js"
export * from "./QueueSelect.vue?vue&type=script&lang=js"
import style0 from "./QueueSelect.vue?vue&type=style&index=0&id=427b7252&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QSpinner,QItem,QItemSection,QItemLabel,QTooltip,QField});
